import { Divider } from '@mui/material';

export default function ToolbarDivider() {
    return (
        <Divider
            orientation="vertical"
            flexItem
            sx={{ borderColor: 'divider' }}
        />
    );
}
